import { graphql } from 'gatsby';
import Gallery from '@components/Gallery/Gallery';
import * as React from 'react';
export default {
  graphql,
  Gallery,
  React
};